module.exports = __webpack_public_path__ + "static/media/logotext.68126e47.png";